module.exports = __webpack_public_path__ + "img/3.8564e5bf.svg";